import styled from '@emotion/styled';

const NavBarContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export { NavBarContainer };
